module.exports = __webpack_public_path__ + "images/ce54db57478b4ee0056c3ae12ef6c9ec5b2d37ea6337a19e3fa85f4b7682e89b.svg";